import type {FullProduct} from '@/models/productModel'

export function getSelectedVariantFromSelectedOptions(
  variations: FullProduct['variations'],
  selectedOptions: Map<string, string>,
) {
  if (variations.length > 0) {
    // Get the first variation satisfied the selected options
    const entries = Array.from(selectedOptions.entries())

    const variation = variations.find(variation => {
      const result = entries.map(([name, value]) => {
        return variation.values.get(name) === value
      })
      return result.every(Boolean)
    })

    if (variation) {
      return variation
    }
  }
}

export function getLooseSelectedVariantFromSelectedOptions(
  variations: FullProduct['variations'],
  selectedOptions: Map<string, string>,
  desiredOption: string,
) {
  if (variations.length > 0) {
    // Get the first variation satisfied the selected options
    const entries = Array.from(selectedOptions.entries())

    // Move the desired option to the begining of the array
    const desiredOptionIndex = entries.findIndex(([name]) => name === desiredOption)
    if (desiredOptionIndex !== -1) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- its guaranteed to be exist
      entries.splice(0, 0, entries.splice(desiredOptionIndex, 1)[0]!)
    }

    // Continue to remove the last option until we can find a variation
    while (entries.length > 1) {
      entries.pop()

      const variation = variations.find(variation => {
        const result = entries.map(([name, value]) => {
          return variation.values.get(name) === value
        })
        return result.every(Boolean)
      })

      if (variation) {
        return variation
      }
    }
  }
}
